import { queryActivityBanner } from "@/api/activity";
import { queryLiveDetailServ } from "@/api/live";
import { ApiGetWxConfig } from "@/api/wx-config";
import { ReactComponent as ToTopIcon } from "@/assets/toTop.svg";
import BottomNotice from "@/components/bottom-notice";
import DailyRewardNotice from "@/components/daily-reward-notice";
import LiveSmallWindow from "@/components/live/live-small-window";
import { VcSceneProvider } from "@/components/product-waterfall";
import RedPacketNotice from "@/components/red-packet-notice";
import { NavigationBarRef } from "@/components/top-navigation";
import VerticalScrollview from "@/components/vertical-scrollview";
import { useCommonContext } from "@/utils/context/common";
import { default as useDomObserver } from "@/utils/hooks/useDomObserver";
import { default as useStickyStateObserver } from "@/utils/hooks/useStickyStateObserver";
import { pxtorem } from "@/utils/pxtorem";
import useNavigation from "@/utils/useNavigate";
import {
  activityAPI,
  ActivityBrandModel,
  ActivityModel,
  LabelPageId,
  ResourceBannerModel,
  VideoCardScene,
} from "@akc/biz-api";
import { BannerComp, TrackDataContext } from "@akc/mx-taro-h5-components";
import { PullToRefresh } from "antd-mobile";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useActivate, useUnactivate } from "react-activation";
import { useParams, useSearchParams } from "react-router-dom";
import ActivityCouponPopup from "./components/ActivityCouponPopup";
import ActivityDesc from "./components/ActivityDesc";
import ActivityEnding from "./components/ActivityEnding";
import ActivitySelector from "./components/ActivitySelector";
import CategoryAndSize from "./components/CategoryAndSize";
import FollowWX from "./components/FollowWX";
import Footer from "./components/Footer";
import Header from "./components/Header";
import LiveFloatingBubble from "./components/LiveFloatingBubble";
import MaterialList from "./components/MaterialList";
import Navigation from "./components/Navigation";
import ProductList from "./components/ProductList";
import ProductStatusTab from "./components/ProductStatusTab";
import SelectionHeader from "./components/SelectionHeader";
import SortAndFilter from "./components/SortAndFilter";
import VerticalNavComp from "./components/VerticalNavComp";
import {
  ActivityProductProvider,
  useSelectedActivity,
  useVerticalNavGray,
} from "./hooks/useActivityProduct";
import styles from "./index.module.less";

interface ExtraActivityModel {
  /** 品牌素材信息 */
  materialResult?: {
    total: string | number;
    materialsResultVOList: ({ materialNo: string } & Record<string, any>)[];
  };
}

interface ActivityContentProps {
  headerDomRef?: React.RefObject<HTMLDivElement>;
  brandData?: ActivityBrandModel & ExtraActivityModel;
  activity?: ActivityModel;
  isOver: boolean;
  onCategoryShowOrHide?: (show: boolean) => void;
  // 进入直播间埋点
  onEnterLiveTrack?: (trackOpts) => void;
}

const ActivityContent: React.FC<ActivityContentProps> = props => {
  const params = useParams();
  const activity = props.activity;
  const waterfallContainerDom = useRef<HTMLDivElement>(null);
  const [updateActivity, setUpdateActivity] = useState(false);
  const [search] = useSearchParams();
  const sortAndFilterDomRef = useRef<any>(null);
  // 添加对VerticalNavComp组件的ref引用
  const verticalNavCompRef = useRef<any>(null);
  const [bannerList, setBannerList] = useState<ResourceBannerModel[]>([]);
  const [activitySelectorOut, setActivitySelectorOut] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<any>(
    search.get("isShowAll") ? undefined : params.activityId,
  );
  const navigationRef = useRef<NavigationBarRef>(null);
  const selectedActivity = useSelectedActivity();
  const verticalNavGray = useVerticalNavGray();

  // 品牌名称前展示的标签，最多2个
  const brandTopLabel = useMemo(() => {
    if (!activity || !Array.isArray(activity?.labelLocationVOList)) {
      return [];
    }
    const brandLabels = activity.labelLocationVOList.find(
      item => item.locationCode === "H5_ScheduleDetail_BrandDown",
    );
    // 已经跟产品确认，前端不控制标签，管理后台控制
    return brandLabels?.labelInfoVOList || [];
    // if (!brandLabels || !Array.isArray(brandLabels?.labelInfoVOList)) {
    //   return [];
    // }
    // // "物流停运标签"
    // const codes1 = ["DATE_LABEL"];
    // const result = brandLabels.labelInfoVOList.filter(
    //   item => !!item.labelCode && codes1.includes(item.labelCode),
    // );
    // // 实测该地方只能展示1-2个标签，所以取前1个(需要考虑品牌名本身很长) 后续考虑推动为需求来变更
    // if (brandLabels.labelInfoVOList.length > 1) {
    //   return result.slice(0, 1);
    // }
    // return result;
  }, [activity]);
  // 直播详情
  const [liveDetail, setLiveDetail] = useState<any>(null);
  const [showSmallWindow, setShowSmallWindow] = useState(false);

  // 直播视频背景大卡曝光状态变化，视频背景大卡隐藏，则展示直播小窗
  const handleSetShowSmallWindow = useCallback((show: boolean) => {
    setShowSmallWindow(show);
  }, []);

  useEffect(() => {
    if (!props.brandData?.brandId) {
      return;
    }
    queryActivityBanner().then(res => setBannerList(res));
  }, [props.brandData]);

  const isCategoryTabSticky = useRef(false);
  const isCategoryTabStickyBeforeUnactivate = useRef(false);
  useUnactivate(() => {
    isCategoryTabStickyBeforeUnactivate.current = isCategoryTabSticky.current;
  });
  useActivate(() => {
    isCategoryTabSticky.current = isCategoryTabStickyBeforeUnactivate.current;
  });

  const productWaterfallDom = useRef<HTMLDivElement>(null);
  const sortAndFilterWrapper = useRef<HTMLDivElement>(null);
  useStickyStateObserver(sortAndFilterWrapper.current, isSticky => {
    isCategoryTabSticky.current = isSticky;
  });

  const isActivitySelectorSticky = useRef(false);
  const selectorContainerDom = useRef<HTMLDivElement>(null);
  const [activitySelectorBgColor, setActivitySelectorBgColor] = useState<string>("");

  useStickyStateObserver(selectorContainerDom.current, isSticky => {
    setActivitySelectorBgColor(isSticky ? "#fff" : "#fff");
    isActivitySelectorSticky.current = isSticky;
  });

  useDomObserver(selectorContainerDom.current, out => {
    console.log("监听位置--------", out);
    setActivitySelectorOut(out);
  });

  const overviewContainerDomRef = useRef<HTMLDivElement>(null);

  const hasActivityBizImg = props.brandData?.activityList?.some(item => !!item.activityBizImg);

  const hasActivityList = !!(
    props.brandData?.activityList && props.brandData?.activityList?.length > 1
  );

  // 查直播详情（这里其实应该不用查详情，直接取liveSimpleVO已经够用）
  useEffect(() => {
    const { liveNo } = props?.activity?.liveSimpleVO || {};
    if (!liveNo) {
      return;
    }
    queryLiveDetailServ(liveNo).then(res => {
      setLiveDetail(res || null);
      setShowSmallWindow(res?.liveStatus === 10 ? true : false);
    });
    // eslint-disable-next-line
  }, [props?.activity?.liveSimpleVO?.liveNo]);

  return (
    <VerticalScrollview
      className={`ActivityContent ${styles.container} ${props.isOver ? styles.empty : ""}`}
      onMoveUpAtBottom={() => {
        console.log("move up~~~~");
      }}>
      <Navigation ref={navigationRef} showSearchIcon={!props.isOver}>
        <SelectionHeader
          showSelectionInHeader={false}
          // onClickSelection={() =>
          //   waterfallContainerDom.current?.scrollIntoView({ behavior: "smooth" })
          // }
        />
      </Navigation>

      {!props.isOver && (
        <>
          {/* 直播小窗 */}
          {[10, 20].includes(liveDetail?.liveStatus) ? (
            <LiveSmallWindow
              visible={showSmallWindow}
              liveSimpleVO={liveDetail}
              onEnterLiveTrack={props.onEnterLiveTrack}
            />
          ) : null}

          {/* 顶部header（含品牌卡片、直播背景大卡） */}
          <div className="HeaderBox" ref={props.headerDomRef}>
            <Header
              brandTopLabel={brandTopLabel}
              brandData={props.brandData}
              isInitialFollowing={props.activity?.focusStatus === 1}
              liveDetail={liveDetail}
              setShowSmallWindow={handleSetShowSmallWindow}
            />
          </div>

          {/* 关注微信公告栏 */}
          <div
            className={`${styles.followWXContainer} ${liveDetail?.liveStatus === 20 ? styles.mt0 : ""}`}>
            <FollowWX />
          </div>

          <div
            ref={waterfallContainerDom}
            className={`${styles.waterfallContainer} ${styles.section} ${
              liveDetail?.liveStatus === 20 ? styles.pt12 : ""
            }`}>
            {/* 档期活动tab栏 */}
            {props.brandData?.activityList && props.brandData.activityList.length > 1 && (
              <div ref={selectorContainerDom} className={styles.sticky}>
                <ActivitySelector
                  brandData={props.brandData}
                  borderRadis={0}
                  bgColor={activitySelectorBgColor}
                  initialSelectedActivityId={selectedId}
                  onSelectionChange={id => {
                    if (overviewContainerDomRef.current && isActivitySelectorSticky.current) {
                      overviewContainerDomRef.current?.scrollIntoView();
                    }

                    // 根据导航模式决定调用哪个组件的resetFilter方法
                    if (verticalNavGray) {
                      // 垂直导航模式，调用VerticalNavComp的resetFilter方法
                      verticalNavCompRef.current?.resetFilter?.();
                    } else {
                      // 非垂直导航模式，调用SortAndFilter的resetFilter方法
                      sortAndFilterDomRef.current?.resetFilter?.();
                    }

                    // setSelectedId(id);
                  }}
                />
              </div>
            )}

            {/* 服务、品牌故事 */}
            <div ref={overviewContainerDomRef} className={styles.overviewContainer}>
              <ActivityDesc
                brandId={props.activity?.brandId}
                brandData={props.brandData}
                updateActivity={updateActivity}
              />
              <MaterialList />
            </div>

            {/* 活动banner轮播 */}
            {bannerList.length > 0 && (
              <BannerComp className={styles.bannerContainer} bannerList={bannerList} />
            )}

            {/* 垂直导航 */}
            {verticalNavGray ? (
              <VerticalNavComp ref={verticalNavCompRef} hasActivityList={hasActivityList} />
            ) : (
              <>
                <CategoryAndSize
                  onCategoryShowOrHide={props.onCategoryShowOrHide}
                  onSelectionChange={() => {
                    sortAndFilterDomRef.current.resetFilter?.();
                  }}
                />
                <div
                  ref={sortAndFilterWrapper}
                  className={styles.sticky}
                  style={{
                    zIndex: 3,
                    top:
                      props.brandData?.activityList && props.brandData.activityList.length > 1
                        ? pxtorem(hasActivityBizImg ? 112 : 99)
                        : pxtorem(44),
                  }}>
                  {/* 排序筛选组件 */}
                  <SortAndFilter
                    ref={sortAndFilterDomRef}
                    brandData={props.brandData}
                    onSortFilterChange={() => {
                      // TODO
                      productWaterfallDom.current?.scrollIntoView();
                      // console.log("11", isCategoryTabSticky.current);
                      // if (isCategoryTabSticky.current) {
                      //   productWaterfallDom.current?.scrollIntoView();
                      // }
                    }}
                  />
                </div>
                <ProductStatusTab
                  brandData={props.brandData}
                  onChange={() => {
                    productWaterfallDom.current?.scrollIntoView();
                  }}
                />
                <div
                  ref={productWaterfallDom}
                  style={{
                    scrollMarginTop:
                      props.brandData?.activityList && props.brandData.activityList.length > 1
                        ? pxtorem(140)
                        : pxtorem(88),
                  }}
                  className={styles.waterfallWrapper}>
                  <VcSceneProvider value={VideoCardScene.videoCardScheduleDetail}>
                    <ProductList onCartChange={navigationRef.current?.triggerAddCartSuccess} />{" "}
                  </VcSceneProvider>
                </div>
              </>
            )}
          </div>
        </>
      )}

      {props.isOver && props.activity && <ActivityEnding activity={props.activity} />}

      {/* <LiveFloatingBubble activityId={selectedActivity?.activityId} /> */}
      {/* 漂浮在底部的通告栏 */}
      <BottomNotice isActivity />
      {!props.isOver && <ActivityCouponPopup updateActivity={() => setUpdateActivity(true)} />}
    </VerticalScrollview>
  );
};

// 档期详情页
const Activity: React.FC = () => {
  const { navigate2LiveRoom } = useNavigation();
  const params = useParams();
  // 品牌及其下所有档期列表
  const [brandData, setBrandData] = useState<ActivityBrandModel & ExtraActivityModel>({});
  const [showSelectionInHeader, setShowSelectionInHeader] = useState(false);
  // 当前档期数据
  const [activity, setActivity] = useState<ActivityModel>();
  const [search] = useSearchParams();
  const { track, isExternal } = useCommonContext();

  const isOver = (activity?.status !== 1 && activity?.status !== 2) || !!activity?.isActivityExpire;

  const pageView = (data = activity) => {
    const showTab = brandData.activityList?.length !== 1;
    const isShowAll = search.get("isShowAll");
    const activityId = isShowAll
      ? brandData.activityList?.map(i => i.activityId).join(",")
      : params.activityId;

    track.track?.("$pageview", {
      page_name: "品牌活动",
      tab_name: showTab
        ? isShowAll
          ? "全部"
          : brandData.activityList?.find(i => i.activityId === params.activityId)?.activityAggrTitle
        : undefined,
      tab_id: showTab ? activityId : undefined,
      tab_rank: showTab
        ? isShowAll
          ? 0
          : (brandData.activityList?.map(i => i.activityId).indexOf(params.activityId) ?? 0 + 1)
        : undefined,
      activity_id: activityId,
      live_no: data?.liveSimpleVO?.liveNo || "",
      live_name: data?.liveSimpleVO?.liveTitle || "",
    });
  };

  const onCategoryShowOrHide = useCallback(show => {
    setShowSelectionInHeader(!show);
  }, []);

  useEffect(() => {
    if (!params.activityId) {
      return;
    }
    Promise.all([
      // activity/multiActivityBrandPageInfo 接口,查当前活动所属品牌信息，及品牌下所有活动信息
      activityAPI.queryActivityBrandData({
        activityId: params.activityId,
        pageId: LabelPageId.h5ActivityDetail,
        queryType: search.get("queryType") ?? undefined,
      }),
      // activity/info 接口,查当前活动信息
      activityAPI.queryActivityData({
        activityId: params.activityId,
        pageId: LabelPageId.h5ActivityDetail,
      }),
    ]).then(datas => {
      const data = datas[1] as ActivityModel & ExtraActivityModel;
      if (!data?.brandId) {
        return;
      }
      setActivity(data);
      const brandData = datas[0];
      if (!brandData?.brandId) {
        return;
      }
      brandData.activityList?.forEach((item, index) => (item.rank = index));
      if (brandData.activityList && brandData.activityList.length > 1) {
        brandData.activityList.unshift({
          activityAggrTitle: "全部",
          activityAggrSubTitleList: [`共${brandData.totalOnlineProductCount}款`],
          brandStoryVO: brandData.activityList[0].brandStoryVO,
          merchantShopCode: brandData.activityList[0].merchantShopCode,
          brandId: brandData.brandId,
          backgroundBrandVideoUrl: brandData.activityList[0].backgroundBrandVideoUrl,
        });
      }
      setBrandData({
        ...brandData,
        materialResult: data.materialResult,
      });
      pageView(data);
    }).catch(err => {
      console.error("初始化档期数据报错", err);
    });
  }, []);

  useEffect(() => {
    document.title = brandData?.brandName ?? "活动详情";
  }, [brandData]);

  useActivate(() => {
    pageView();
    document.title = brandData?.brandName ?? "活动详情";
  });

  // 埋点上下文数据设置
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { setTrackData } = useContext(TrackDataContext);
  useEffect(() => {
    setTrackData({
      page_name: "品牌活动",
      previous_page_name: params.fromPage ?? "",
    });
  }, []);

  // 仅有1个档期时，忽略 isShowAll 参数
  const initialSelectedActivityId =
    search.get("isShowAll") && (brandData?.activityList?.length ?? 0) > 1
      ? undefined
      : params.activityId;
  const headerDomRef = useRef<HTMLDivElement>(null);

  // 跳转直播间埋点
  const enterLiveTrack = trackOpts => {
    track.track?.("live_entrance_click", {
      ...(trackOpts || {}),
      page_name: "品牌活动",
      previous_page_name: params.fromPage ?? "",
      merchant_shop_code: "",
      activity_id: activity?.activityId,
    });
  };

  // 页面下拉
  const handleRefresh = async () => {
    // 如果直播正在直播中，则跳转到直播房间（直播背景大卡的逻辑）
    const { liveNo, liveStatus, liveTitle, liveType } = (activity as any)?.liveSimpleVO || {};
    if (liveNo && liveStatus === 20) {
      enterLiveTrack({
        domain: "直播背景大卡",
        resource_type: "",
        resource_content: "",
        live_status: liveStatus === 20 ? "直播中" : liveStatus === 10 ? "直播预告" : "直播结束",
        live_no: liveNo,
        live_name: liveTitle,
        live_type: liveType,
        btn_name: "进入直播",
      });
      navigate2LiveRoom({
        liveId: liveNo,
        liveStatus: liveStatus,
      });
    }
  };

  return (
    <PullToRefresh onRefresh={handleRefresh} disabled={!(activity as any)?.liveSimpleVO}>
      <ActivityProductProvider
        initialSelectedActivityId={initialSelectedActivityId}
        activityList={brandData.activityList}>
        <ActivityContent
          headerDomRef={headerDomRef}
          brandData={brandData}
          activity={activity}
          isOver={isOver}
          onCategoryShowOrHide={onCategoryShowOrHide}
          onEnterLiveTrack={enterLiveTrack}
        />

        <ToTopIcon
          className={`${styles.toTopIcon} ${showSelectionInHeader ? "" : styles.hide}`}
          onClick={() => {
            headerDomRef.current?.scrollIntoView({ behavior: "smooth" });
          }}
        />

        {/* 底部按钮栏及分享海报弹窗 poster-swiper */}
        {!isOver && !isExternal && (
          <Footer brandData={brandData} activityList={brandData?.activityList || []} activity={activity}/>
        )}
        
        <RedPacketNotice />
        <DailyRewardNotice />
      </ActivityProductProvider>
    </PullToRefresh>
  );
};

export default Activity;
